import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Card, CardSection, Loader } from "cxa-components";
import Wallet from "./Wallet";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import OtherBenefits from "./OtherBenefits";
import { getOtherBenefits, saveOtherBenefits } from "../../../../actions/otherBenefitsActions";
import messages from "components/messagesDescription";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { showToast } from "actions/toastActions";
import { RouteMap } from "../../../common/navigation/routeMap";
import { loadNavigationMenu, loadNewNavMenus } from "actions/commonActions";

const IntlContext = React.createContext();
const ScreenContext = React.createContext();
const OtherBenefitsPage = ({ intl, history, isNarrowScreen }) => {
  const dispatch = useDispatch();
  const otherBenefits = useSelector(state => state.otherBenefits);
  const isNewUI = useSelector(state => state.common.clientSettings.newUIFlag);

  useEffect(() => {
    dispatch(getOtherBenefits());
  }, []);

  const handleSubmit = () => {
    dispatch(saveOtherBenefits(otherBenefits.data, postSuccessHandler));
  };

  const postSuccessHandler = () => {
    isNewUI ? dispatch(loadNewNavMenus()) : dispatch(loadNavigationMenu());
    
    dispatch(
      showToast({ message: intl.formatMessage(messages.otherBenefits.toastMessageSuccess) })
    );
    history.push(RouteMap.FlexBenefitsMain_BenefitsStatement);
  };

  return otherBenefits.isFetching || !otherBenefits.data ? (
    <Loader />
  ) : (
    <IntlContext.Provider value={intl}>
      <ScreenContext.Provider value={isNarrowScreen}>
        {otherBenefits.data.length === 0 ? (
          <div>{intl.formatMessage(messages.otherBenefits.noOtherBenefitsAvailable)}</div>
        ) : (
          <Fragment>
            <Wallet data={otherBenefits.data} />
            <Card>
              <OtherBenefits data={otherBenefits.data} />
              {otherBenefits.data.length > 0 && otherBenefits.data[0].otherBenefitsNote && (
                <CardSection>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage(messages.otherBenefits.otherBenefitsNote),
                    }}
                  ></div>
                </CardSection>
              )}
            </Card>
            {otherBenefits.error && <ErrorMessage error={otherBenefits.error.body} intl={intl} />}
            <div className="btn-container" style={{ justifyContent: "flex-end" }}>
              <button
                style={{ cursor: "pointer" }}
                className="button enrolment-btn"
                type="button"
                onClick={handleSubmit}
              >
                {intl.formatMessage(messages.checkOutBenefitsDescription)}
              </button>
            </div>
          </Fragment>
        )}
      </ScreenContext.Provider>
    </IntlContext.Provider>
  );
};

OtherBenefitsPage.propTypes = {
  intl: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool.isRequired,
  history: PropTypes.object,
};
export { IntlContext, ScreenContext };
export default withRouter(injectIntl(OtherBenefitsPage));



// WEBPACK FOOTER //
// ./components/employee/shop/other-benefits/index.js